import { useState } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

// Port aus TagInput.svelte — Liste kurzer Eintraege (Diagnosen, Medikamente …)
// mit Eingabefeld; Enter oder Komma fuegt hinzu, Backspace im leeren Feld
// entfernt den letzten.
type Accent = 'brand' | 'warn' | 'neutral';
const CHIP: Record<Accent, string> = {
  brand:   'border-primary-200 bg-primary-50 text-primary-800',
  warn:    'border-amber-200 bg-amber-50 text-amber-800',
  neutral: 'border-gray-200 bg-gray-100 text-ps-dark-700',
};

export default function TagInput({ label, items, onChange, placeholder, accent = 'neutral' }:
  { label: string; items: string[]; onChange: (v: string[]) => void; placeholder?: string; accent?: Accent }) {
  const [draft, setDraft] = useState('');
  const add = () => {
    const v = draft.trim().replace(/,$/, '').trim();
    if (v && !items.includes(v)) onChange([...items, v]);
    setDraft('');
  };
  return (
    <div>
      <span className="text-[11px] font-medium uppercase tracking-wide text-ps-dark-500">{label}</span>
      <div className="mt-1 flex flex-wrap items-center gap-1.5 rounded-md border border-gray-300 bg-white px-2 py-1.5 focus-within:border-primary-500 focus-within:ring-1 focus-within:ring-primary-500">
        {items.map((it, i) => (
          <span key={`${it}-${i}`} className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs ${CHIP[accent]}`}>
            {it}
            <button type="button" onClick={() => onChange(items.filter((_, j) => j !== i))} aria-label={`${it} entfernen`} className="rounded-full hover:bg-black/10">
              <XMarkIcon className="h-3 w-3" />
            </button>
          </span>
        ))}
        <input value={draft} onChange={(e) => setDraft(e.target.value)} placeholder={placeholder}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ',') { e.preventDefault(); add(); }
            else if (e.key === 'Backspace' && !draft && items.length) onChange(items.slice(0, -1));
          }}
          onBlur={add}
          className="min-w-[8rem] flex-1 border-0 bg-transparent p-0.5 !text-sm focus:outline-none focus:ring-0" />
      </div>
    </div>
  );
}
